import { AvailableShiftsResponse } from "@/models/shift/AvailableShiftsResponse";
import { IShift } from "@/models/shift/Shift";
import React from "react";

type AcceptingRoomTransactionsProps = {
  isAccepting: true;
  currentBorrowerCount: number;
  shifts: IShift[];
};

type RejectingRoomTransactionsProps = {
  isAccepting: false;
};

type RoomTransactionsProps = {
  transactions?: AvailableShiftsResponse;
} & (AcceptingRoomTransactionsProps | RejectingRoomTransactionsProps);

const RoomTransactions: React.FC<RoomTransactionsProps> = (props) => {
  const totalShifts = 6;
  const shiftIds = Array.from({ length: totalShifts }, (_, index) => index + 1);

  return (
    <>
      <h3 className="font-semibold text-lg">Room Transactions</h3>

      <div className="flex justify-between">
        {shiftIds.map((shiftId) => {
          const shift = props.transactions?.shifts.find(
            (s) => s.id === shiftId,
          );

          const currBorrowingShiftIds = props.isAccepting
            ? new Set(props.shifts.map((s) => s.id))
            : undefined;

          return (
            <div
              key={shiftId}
              className={`flex flex-col justify-center items-center gap-1 w-full rounded-md border py-2 px-3 transition-all ${
                shift
                  ? "border-emerald-400 text-white"
                  : "border-red-400/50 text-red-300 opacity-50"
              }`}
            >
              <p className="text-sm font-semibold uppercase tracking-wide">
                Shift {shiftId}
              </p>

              {shift && props.isAccepting && (
                <div className="flex items-baseline gap-[2px] text-sm font-medium">
                  <span className="text-white">{shift?.borrower_count}</span>

                  <span className="font-bold text-emerald-300 ml-1">
                    {currBorrowingShiftIds!.has(shift.id) && (
                      <>(+{props.currentBorrowerCount})</>
                    )}
                  </span>

                  <span className="text-blue-200 text-xs ml-1 opacity-80">
                    / {props.transactions?.room_capacity || 0}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default RoomTransactions;
